import { FiHighlightService } from '@fi-shared/fi-highlight/fi-highlight.service';
import { Component, Input, OnInit } from '@angular/core';
import { DocumentModel } from '../document.model';
import { IDocumentViewData } from '../document-view/document-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DocumentViewService } from '../document-view-service/document-view.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-document-view-state',
    template: `
        @if (data) {
            <fi-document-view
                [document]="document"
                [data]="data"
                [focusNewComment]="focusNewComment"
                [commentId]="commentId"
                (langChange)="onLangChange($event)"
            ></fi-document-view>
        }
    `,
    standalone: false,
})
export class FiDocumentViewStateComponent implements OnInit {
    @Input() focusNewComment: boolean = false;
    @Input() document: DocumentModel;
    @Input() highlightText: string;
    @Input() commentId: number;
    data: IDocumentViewData;

    constructor(
        private state: FiStateService,
        private documentViewService: DocumentViewService,
        private statisticService: StatisticService,
        private highlightService: FiHighlightService,
    ) {}

    ngOnInit() {
        if (!this.document) {
            this.state.go(FiStateNames.Document.List);
            return;
        }

        if (!!this.highlightText) {
            this.highlightService.setHighlightText(this.highlightText);
        }

        this.documentViewService
            .prepareEverythingForView(this.document, this.state.params.languageId)
            .then((documentViewData) => (this.data = documentViewData))
            .catch((reason) => {
                if (reason === 'cancel') {
                    window.history.back();
                } else {
                    throw reason;
                }
            });

        this.statisticService.Visit(ModuleType.Document, ObjectTypes.Document, this.state.params.Id);
    }

    updateLanguageUrl(langId) {
        this.state.go(
            FiStateNames.Document.View,
            {
                Id: this.document.Id,
                languageId: langId,
            },
            {
                inherit: false,
                location: 'replace',
                notify: false,
            },
        );
    }

    onLangChange($event) {
        this.updateLanguageUrl($event);
    }
}
